import { DialogClose } from '@radix-ui/react-dialog'
import { XIcon } from 'lucide-react'
import React, { forwardRef } from 'react'

import { IconButton } from '../IconButton'

type IconButtonProps = React.ComponentProps<typeof IconButton>
interface DismissButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  label?: IconButtonProps['label'];
  size?: IconButtonProps['size'];
}

export const DismissButton = forwardRef<HTMLButtonElement, DismissButtonProps>(({
  label = 'Dismiss dialog',
  size = 'medium',
  ...props
}, forwardedRef) => {
  return (
    <div className='flex items-center justify-center w-4 h-4'>
      <DialogClose asChild>
        <IconButton
          {...props}
          icon={XIcon}
          ref={forwardedRef}
          size={size}
          label={label}
        />
      </DialogClose>
    </div>
  )
})

DismissButton.displayName = 'Modal.DismissButton'
